const {
  EXPERIMENT_ENTITY_ID,
  LAST_DISCARDED_NOTIFICATION,
  LAST_READ_NOTIFICATION,
  MAIN,
  CONSENT,
  HEIMDALL,
  USER_IMPACT,
  LOGIN_BETA,
  TYPETAG_LEGACY,
  SEARCHES_AFTER_INSTALL,
  APP_SNOWPLOW_ID,
  REQUEST_ID,
  UNLEASH,
} = require('../../../common/js/constants/cookies');

const consentCategories = {
  ESSENTIAL: 'e',
  ANALYTICS: 'a',
  MARKETING: 'm',
  PERSONALISATION: 'p',
};

const cookiesList = [
  {
    name: CONSENT,
    description: 'Used to store cookie consent.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: MAIN,
    description: 'Ecosia main cookie',
    sanitizer: 'ecosiaUser',
    multipleValues: true,
    permission: consentCategories.ESSENTIAL,
    permissions: {
      // if a cookie use multiple Value like the ECFG cookie, permissions can be set for each value
      addOn: consentCategories.ESSENTIAL,
      autoSuggestion: consentCategories.ESSENTIAL,
      customSettings: consentCategories.ANALYTICS,
      deviceType: consentCategories.ESSENTIAL,
      adultFilter: consentCategories.ESSENTIAL,
      firstRun: consentCategories.ESSENTIAL,
      firstSearch: consentCategories.ANALYTICS,
      language: consentCategories.ESSENTIAL,
      lastTreePlanted: consentCategories.ESSENTIAL,
      marketApplied: consentCategories.ESSENTIAL,
      notifications: consentCategories.ESSENTIAL,
      newTab: consentCategories.ESSENTIAL,
      personalizedSearch: consentCategories.PERSONALISATION,
      bingUserId: consentCategories.PERSONALISATION,
      treeCount: consentCategories.ESSENTIAL,
      typeTag: consentCategories.ESSENTIAL,
      temperatureUnit: consentCategories.ESSENTIAL,
      windUnit: consentCategories.ESSENTIAL,
    },
  },
  {
    name: LAST_DISCARDED_NOTIFICATION,
    description: 'Saves the timestamps when banner or popup notification was discarded',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: LAST_READ_NOTIFICATION,
    description: 'Saves the timestamp when the notifications center or archive was last opened',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: HEIMDALL,
    description: 'Heimdall access token',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: USER_IMPACT,
    description: 'UserImpact access token',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: EXPERIMENT_ENTITY_ID,
    description: 'Random generated user id for experiments',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    // TODO: The cookie name is very confusing and should be changed
    name: LOGIN_BETA,
    description: 'Used for identifiying previous logged in devices',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: TYPETAG_LEGACY,
    description: 'Stores the typetag (see Parameters used by Analytics).',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: SEARCHES_AFTER_INSTALL,
    description: 'Tracks searches after the extension has been installed.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: 'ENPS',
    description: 'Net Promoter Score survey callout cookie.',
    multipleValues: false,
    permission: consentCategories.MARKETING,
  },
  {
    name: 'sp',
    description: 'Snowplow main cookie.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: APP_SNOWPLOW_ID,
    description: 'Snowplow mobile app users cookie.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: 'ecosia_sp2id.3d5d',
    description: 'Snowplow user id.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: 'ecosia_sp2ses.3d5d',
    description: 'Snowplow ses cookie.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: REQUEST_ID,
    description: 'This value updates with each new query, and the cookie expires with session.',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
  {
    name: UNLEASH,
    description: 'Random generated user id for feature toggles',
    multipleValues: false,
    permission: consentCategories.ESSENTIAL,
  },
];

module.exports = {
  cookiesList,
  consentCategories,
};
